// var Instafeed = require('instafeed.js');

// jQuery(function($) {

//   $('#instagram').append('<ul id="instagram-feed"/>');
//   var userFeed = new Instafeed({
//     target : 'instagram-feed',
//     get: 'user',
//     userId: 249697029,
//     accessToken: '249697029.467ede5.39d51dd3c5474693b31a875b5dc3cf61',
//     resolution: 'low_resolution',
//     limit: 6,
//     template: '<li><a href="{{link}}"><img alt="{{caption}}" src="{{image}}"/></a></li>'
//   });
//   userFeed.run();
// });